import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import showToast from '../../utils/toast';
import AuthLayout from '../../components/auth/AuthLayout';
import authServices from '../../services/AuthServices';

const ResetPassword = () => {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const location = useLocation();

  const mobile = location.state?.mobile || localStorage.getItem('resetMobile') || '';
  const otp = location.state?.otp || '';

  useEffect(() => {
    if (!mobile || !otp) {
      navigate('/forgot-password', { replace: true });
    }
  }, [mobile, otp, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!password || !confirmPassword) {
      setError('Please enter and confirm your new password.');
      return;
    }

    if (password !== confirmPassword) {
      setError('Passwords do not match.');
      return;
    }

    if (password.length < 6) {
      setError('Password must be at least 6 characters long.');
      return;
    }

    setLoading(true);
    setError('');

    try {
      const response = await authServices.resetPassword(mobile, otp, password, confirmPassword);

      if (response.success) {
        showToast.success(response.message || 'Password reset successfully.');

        // Clean up localStorage
        localStorage.removeItem('resetMobile');

        navigate('/login');
      } else {
        const message = response.message || 'Failed to reset password. Please try again.';
        setError(message);
        showToast.error(message);
      }
    } catch (error) {
      // Extract error message from error object
      const message = error.response?.data?.message ||
                     error.response?.data?.error ||
                     error.response?.data?.detail ||
                     error.message ||
                     'An error occurred. Please try again.';
      setError(message);
      showToast.error(message);
      console.error('Reset password error:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleBack = () => {
    navigate('/verify-otp', { state: { mobile } });
  };

  return (
    <AuthLayout
      title="Reset Password"
      subtitle={`Set a new password for ${mobile ? `+91 ${mobile}` : 'your account'}.`}
      onBack={handleBack}
    >
      {error && (
        <div className="toast-error">
          <div className="toast-content">
            <div className="toast-icon">⚠️</div>
            <div className="toast-text">{error}</div>
            <button className="toast-close" onClick={() => setError('')}>
              ×
            </button>
          </div>
        </div>
      )}

      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label className="form-label">New Password</label>
          <div className="password-input-container">
            <input
              type={showPassword ? "text" : "password"}
              className="form-input"
              placeholder="Enter new password"
              value={password}
              onChange={(e) => {
                setPassword(e.target.value);
                if (error) {
                  setError('');
                }
              }}
              required
            />
            <button
              type="button"
              className="password-toggle-btn"
              onClick={() => setShowPassword(!showPassword)}
              aria-label={showPassword ? "Hide password" : "Show password"}
            >
              <i className={`fas ${showPassword ? 'fa-eye-slash' : 'fa-eye'}`}></i>
            </button>
          </div>
        </div>

        <div className="form-group">
          <label className="form-label">Confirm Password</label>
          <div className="password-input-container">
            <input
              type={showConfirmPassword ? "text" : "password"}
              className="form-input"
              placeholder="Confirm new password"
              value={confirmPassword}
              onChange={(e) => {
                setConfirmPassword(e.target.value);
                if (error) {
                  setError('');
                }
              }}
              required
            />
            <button
              type="button"
              className="password-toggle-btn"
              onClick={() => setShowConfirmPassword(!showConfirmPassword)}
              aria-label={showConfirmPassword ? "Hide password" : "Show password"}
            >
              <i className={`fas ${showConfirmPassword ? 'fa-eye-slash' : 'fa-eye'}`}></i>
            </button>
          </div>
        </div>

        <button type="submit" className="signin-btn" disabled={loading}>
          {loading ? 'Updating password...' : 'Update Password'}
        </button>
      </form>
    </AuthLayout>
  );
};

export default ResetPassword;


